import styles from "./Generic.module.css";
import { FC } from "react";
type Props = {
  children: string;
};

export const Title: FC<Props> = ({ children }) => {
  return <p className={styles.titleText}>{children}</p>;
};
